export default __webpack_public_path__ + "static/media/paging_next_disabled.df22d322.svg";